import { render, staticRenderFns } from "./DatePickerButton.vue?vue&type=template&id=23541dbe&scoped=true&"
import script from "./DatePickerButton.vue?vue&type=script&lang=js&"
export * from "./DatePickerButton.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerButton.vue?vue&type=style&index=0&id=23541dbe&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23541dbe",
  null
  
)

export default component.exports